export default __webpack_public_path__ + "static/media/Student.3f1b6648.svg";